import {
  doesNodeHaveAnInputHandle,
  doesNodeHaveAnOutputHandle,
} from 'processes/graph-builder/flowchart-viz/util/ConvertFlowchartForReactFlowUtil';
import {
  ProcessFlowchartInteractiveNode,
  ProcessFlowchartNodeType,
  ProcessFlowchartStaticEdge,
  ProcessFlowchartStaticNode,
} from 'processes/graph-builder-processes/flowchart-viz/ProcessFlowchartVizConstants';
import {
  isOutputNode,
  isRootNode,
  isEndNode,
} from 'processes/graph-builder-processes/flowchart-viz/util/getNodeDetailsTypeForInteractiveNode';

export function getNodeTypeForProcessInteractiveFlowchart(
  node: ProcessFlowchartInteractiveNode,
  flowchartTaskSchemaId: string
): ProcessFlowchartNodeType {
  if (isRootNode(node)) {
    // Only the flowchart root task node does not have an input handle
    return ProcessFlowchartNodeType.START_NODE;
  } else if (isOutputNode(node)) {
    return ProcessFlowchartNodeType.END_NODE;
  } else if (isEndNode(node)) {
    return ProcessFlowchartNodeType.END_NODE;
  }
  return ProcessFlowchartNodeType.MIDDLE_NODE;
}

export function getNodeTypeForProcessStaticFlowchart(
  node: ProcessFlowchartStaticNode,
  edges: Array<ProcessFlowchartStaticEdge>
): ProcessFlowchartNodeType {
  const hasInputHandle = doesNodeHaveAnInputHandle(node, edges);
  const hasOutputHandle = doesNodeHaveAnOutputHandle(node, edges);
  if (!hasInputHandle && !hasOutputHandle) {
    return ProcessFlowchartNodeType.DISCONNECTED_NODE;
  } else if (!hasInputHandle) {
    return ProcessFlowchartNodeType.START_NODE;
  } else if (!hasOutputHandle) {
    return ProcessFlowchartNodeType.END_NODE;
  }
  return ProcessFlowchartNodeType.MIDDLE_NODE;
}

export function getClientIdForProcessFlowchartEdge(fromNodeClientId: string, toNodeClientId: string): string {
  return `e${fromNodeClientId}/${toNodeClientId}`;
}

export function getTargetHandleIdForEdge(edgeId: string): string {
  return `${edgeId}-target`;
}

const _END_OF_FLOWCHART_NODE_ID = '_END_OF_FLOWCHART_NODE_ID';

export const getCollapsedNodeClientId = (fromNodeId: string, toNodeId: string | null): string =>
  `collapsedNode:${fromNodeId}/${toNodeId ?? _END_OF_FLOWCHART_NODE_ID}`;
